var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCylinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    height: 800,
    width: 800,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.621 38.187C414.763 1.216 272.789 0 256 0S97.237 1.216 86.379 38.187c-.64 1.387-1.045 2.859-1.045 4.48v426.667c0 1.621.405 3.093 1.045 4.48C97.237 510.784 239.211 512 256 512s158.763-1.216 169.621-38.187c.64-1.387 1.045-2.859 1.045-4.48V42.667c.001-1.622-.405-3.094-1.045-4.48zM256 21.333c87.723 0 137.685 13.248 148.075 21.333C393.685 50.752 343.723 64 256 64S118.315 50.752 107.925 42.667c10.39-8.086 60.352-21.334 148.075-21.334zm149.333 446.656c-6.101 7.851-56.448 22.677-149.333 22.677-93.995 0-144.619-15.211-149.333-21.333V65.429C149.312 84.544 242.603 85.333 256 85.333s106.688-.789 149.333-19.904v402.56z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinder);
export default __webpack_public_path__ + "static/media/cylinder.d9b3e5d055936c074d101a6c8542eb87.svg";
export { ForwardRef as ReactComponent };